// extracted by mini-css-extract-plugin
export default {"zoomModal":"M1-z","image":"N1-z","button":"O1-z","isOverlayShown":"P1-z"};